import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useAppointmentTypes() {
  const navigate = useNavigate();

  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAppointmentTypes = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/appointment-types', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setAppointmentTypes(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchAppointmentTypes();
  }, [fetchAppointmentTypes]);

  return { appointmentTypes, isLoading, error, refetch: fetchAppointmentTypes };
}
